import { ActiveSelection } from "fabric";

export default {
  serializeCanvasToBlob(canvas: ActiveSelection, config) {
    // process and ensure export config is valid
    const fileType = config.fileType === "image/jpeg" ? config.fileType : "image/png";
    const format = fileType.split("/")[1];
    const multiplier = config.multiplier ? config.multiplier : 1;

    // convert canvas to data URL
    const canvasDataUrl = canvas.toDataURL({
      format: format,
      multiplier: multiplier,
    });

    // convert data URL to BLOB
    const binStr = atob(canvasDataUrl.split(",")[1]);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: fileType });
  },
  serializeBase64ToBlob(base64, config) {
    const binStr = atob(base64.split(",")[1]);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: config.fileType });
  },
};
